export default __webpack_public_path__ + "static/media/top-trending.7c3f871e.png";